import * as React from "react";
import { useGlobalStore } from "../../../contexts/StoreContext";
import { Tabs, notification } from "antd";
// import { getCasePayload } from "../../../utils";
// import { keepPreviousData, useQuery } from "@tanstack/react-query";
// import { getAgentManagerActiveCases, getAgentManagerPendingCases } from "../../../services/agentManagerController";
import { TableView } from "./TableView";

interface ManagerTableProps {
  tableProps: any;
}

export const ManagerTable: React.FC<ManagerTableProps> = ({ tableProps }) => {
  // const [states, setStates] = React.useState({
  //   loader: true,
  //   page: 1,
  //   pageSize: 10,
  //   caseData: [],
  //   totalRecords: 0,
  // });
  const { state, dispatch } = useGlobalStore();
  //const { activeTabKey } = state;
  const [api, contextHolder] = notification.useNotification();

  // const payload = getCasePayload(state);
  // const {
  //   data: activeCases,
  //   isPending: isActiveCasesPending,
  //   isRefetching: isActiveCasesRefetching,
  // } = useQuery({
  //   queryKey: ["agentManagerActiveCases", payload],
  //   queryFn: () => getAgentManagerActiveCases(payload),
  //   enabled: activeTabKey === "2",
  //   placeholderData: keepPreviousData,
  // });
  // const {
  //   data: pendingCases,
  //   isPending: isPendingCasesPending,
  //   isRefetching: isPendingCasesRefetching,
  // } = useQuery({
  //   queryKey: ["agentManagerActiveCases", payload],
  //   queryFn: () => getAgentManagerPendingCases(payload),
  //   enabled: activeTabKey === "1",
  //   placeholderData: keepPreviousData,
  // });

  const items = [
    {
      label: "Pending Case",
      key: "1",
      children: <TableView tableProps={tableProps} caseType="managerPending" />,
    },
    {
      label: "Active Cases",
      key: "2",
      children: <TableView tableProps={tableProps} caseType="managerActive" />,
    },
  ];

  const setActiveTabKey = (e: string) => {
    dispatch({ type: "SET_ACTIVE_TAB_KEY", payload: e });
  };

  // const openNotification = (title?: string, description?: string) => {
  //   api.open({
  //     message: title ? title : "Solveesy",
  //     description: description ? description : "",
  //     duration: 3,
  //   });
  // };

  // React.useEffect(() => {
  //   const tempTableData = state.activeTabKey === "1" ? pendingCases : activeCases;
  //   if (tempTableData && Object.hasOwnProperty.call(tempTableData, "info")) {
  //     openNotification("", tempTableData?.info);
  //   }
  // }, [activeCases, pendingCases]);

  return (
    <>
      {contextHolder}
      <Tabs items={items} onChange={setActiveTabKey} activeKey={state.activeTabKey} />
    </>
  );
};
